import { AxiosResponse } from "axios";
import axiosInstance from "../api/axios";

export const respondUserRequest = async (
  userId: number,
  approvalRequestId: number,
  requestResponse: "Pending" | "Rejected" |"Verified" | "Confirmed",
  reason?: string
) => {
  try {
    console.log("rejection before api call", reason);
    const response: AxiosResponse<any> = await axiosInstance.post(
      "/user-approval-request/approve",
      {
        user_id: userId,
        approval_request_id: approvalRequestId,
        status: requestResponse,
        reason: "Invalid Document",
      }
    );
    console.log("Requested successfully:", response.data);
    return response.data;
    // Handle success (e.g., navigate to another page)
  } catch (error: any) {
    console.error(
      "Account request failed:",
      error.response?.data || error.message
    );
    // Handle failure (e.g., show an error message)
    return null;
  }
};
